/*
 * i18next-scanner cannot resolve the data-driven translate() calls below.
 * Keep these static references aligned with BROWSE_COPY so locale sync can
 * maintain the centralized English fallbacks.
 * t('pmh2.browse.title', 'Picture My Heritage')
 * t('pmh2.browse.headline', 'Picture yourself in your ancestors’ world.')
 * t('pmh2.browse.intro', 'Pick a heritage to step into — then take one selfie and see yourself in it.')
 * t('pmh2.browse.loading', 'Finding your heritage Portraits…')
 * t('pmh2.browse.filter.heritage', 'Heritage')
 * t('pmh2.browse.filter.male', 'Male')
 * t('pmh2.browse.filter.female', 'Female')
 * t('pmh2.browse.filter.group', 'Group')
 * t('pmh2.browse.tablist-label', 'Heritage Portrait categories')
 * t('pmh2.browse.empty.portraits', 'No Portraits to show yet.')
 * t('pmh2.browse.empty.heritage.title', 'More family connections can unlock heritage Portraits.')
 * t('pmh2.browse.empty.heritage', 'Add family details in Family Tree, then come back to explore.')
 * t('pmh2.browse.empty.heritage-guest', 'Sign in to match heritage Portraits to your family tree.')
 * t('pmh2.browse.update-family-tree', 'Update Family Tree')
 * t('pmh2.browse.sign-in', 'Sign in')
 * t('pmh2.browse.retry', 'Try again')
 * t('pmh2.browse.retry-hint', 'Attempts to load your heritage Portraits again.')
 * t('pmh2.browse.error.heritage', 'We couldn’t load your heritage Portraits.')
 * t('pmh2.browse.fallback.tree-unavailable', 'Your family tree could not be loaded, so these suggestions use your surname instead.')
 * t('pmh2.browse.portrait.unavailable', 'This Portrait is unavailable.')
 * t('pmh2.browse.percentage', '{percentage}')
 * t('pmh2.browse.percentage-accessibility', '{percentage} percent heritage')
 * t('pmh2.browse.detail-accessibility', '{country}, {percentage} percent heritage')
 * t('pmh2.browse.portrait.open-hint', 'Opens this Portrait.')
 * t('pmh2.browse.portrait.label', 'Portrait')
 * t('pmh2.browse.group-portrait', 'Group portrait')
 * t('pmh2.browse.capture.take', 'Take photo')
 * t('pmh2.browse.portrait.back', 'Back to Portraits')
 * t('pmh2.browse.portrait.navigation', 'Portrait navigation')
 * t('pmh2.browse.portrait.frame-accessibility', 'Heritage Portrait preview')
 * t('pmh2.browse.portrait.headline', 'Picture yourself in {country} dress.')
 * t('pmh2.browse.portrait.subline', '{percentage} of your ancestors were from {country}.')
 * t('pmh2.browse.portrait.subline-unmatched', 'Not in your tree — try it on anyway.')
 *
 * These data-driven runtime labels have no literal call site. Keep their
 * English source entries harvestable and assert catalog coverage in copy.test.
 * t('pmh.ethnicities.dutch.female', 'Dutch')
 * t('pmh.ethnicities.french.female', 'French')
 * t('pmh.ethnicities.french.male', 'French')
 * t('global.countries.countryGB-NIR', 'Northern Ireland')
 * t('global.countries.countrySS', 'South Sudan')
 */
export const BROWSE_COPY = Object.freeze({
  title: {
    key: 'pmh2.browse.title',
    defaultValue: 'Picture My Heritage',
  },
  headline: {
    key: 'pmh2.browse.headline',
    defaultValue: 'Picture yourself in your ancestors’ world.',
  },
  intro: {
    key: 'pmh2.browse.intro',
    defaultValue: 'Pick a heritage to step into — then take one selfie and see yourself in it.',
  },
  loading: {
    key: 'pmh2.browse.loading',
    defaultValue: 'Finding your heritage Portraits…',
  },
  heritage: {
    key: 'pmh2.browse.filter.heritage',
    defaultValue: 'Heritage',
  },
  male: {
    key: 'pmh2.browse.filter.male',
    defaultValue: 'Male',
  },
  female: {
    key: 'pmh2.browse.filter.female',
    defaultValue: 'Female',
  },
  group: {
    key: 'pmh2.browse.filter.group',
    defaultValue: 'Group',
  },
  tablistLabel: {
    key: 'pmh2.browse.tablist-label',
    defaultValue: 'Heritage Portrait categories',
  },
  noPortraits: {
    key: 'pmh2.browse.empty.portraits',
    defaultValue: 'No Portraits to show yet.',
  },
  noHeritageTitle: {
    key: 'pmh2.browse.empty.heritage.title',
    defaultValue: 'More family connections can unlock heritage Portraits.',
  },
  noHeritage: {
    key: 'pmh2.browse.empty.heritage',
    defaultValue: 'Add family details in Family Tree, then come back to explore.',
  },
  noHeritageGuest: {
    key: 'pmh2.browse.empty.heritage-guest',
    defaultValue: 'Sign in to match heritage Portraits to your family tree.',
  },
  updateFamilyTree: {
    key: 'pmh2.browse.update-family-tree',
    defaultValue: 'Update Family Tree',
  },
  signIn: {
    key: 'pmh2.browse.sign-in',
    defaultValue: 'Sign in',
  },
  retry: {
    key: 'pmh2.browse.retry',
    defaultValue: 'Try again',
  },
  retryHint: {
    key: 'pmh2.browse.retry-hint',
    defaultValue: 'Attempts to load your heritage Portraits again.',
  },
  ancestryRankingError: {
    key: 'pmh2.browse.error.heritage',
    defaultValue: 'We couldn’t load your heritage Portraits.',
  },
  treeUnavailableFallback: {
    key: 'pmh2.browse.fallback.tree-unavailable',
    defaultValue: 'Your family tree could not be loaded, so these suggestions use your surname instead.',
  },
  portraitUnavailable: {
    key: 'pmh2.browse.portrait.unavailable',
    defaultValue: 'This Portrait is unavailable.',
  },
  percentage: {
    key: 'pmh2.browse.percentage',
    defaultValue: '{percentage}',
  },
  percentageAccessibility: {
    key: 'pmh2.browse.percentage-accessibility',
    defaultValue: '{percentage} percent heritage',
  },
  detailAccessibility: {
    key: 'pmh2.browse.detail-accessibility',
    defaultValue: '{country}, {percentage} percent heritage',
  },
  portraitOpenHint: {
    key: 'pmh2.browse.portrait.open-hint',
    defaultValue: 'Opens this Portrait.',
  },
  portraitLabel: {
    key: 'pmh2.browse.portrait.label',
    defaultValue: 'Portrait',
  },
  groupPortrait: {
    key: 'pmh2.browse.group-portrait',
    defaultValue: 'Group portrait',
  },
  takePhoto: {
    key: 'pmh2.browse.capture.take',
    defaultValue: 'Take photo',
  },
  portraitBack: {
    key: 'pmh2.browse.portrait.back',
    defaultValue: 'Back to Portraits',
  },
  portraitNavigation: {
    key: 'pmh2.browse.portrait.navigation',
    defaultValue: 'Portrait navigation',
  },
  portraitFrameAccessibility: {
    key: 'pmh2.browse.portrait.frame-accessibility',
    defaultValue: 'Heritage Portrait preview',
  },
  portraitHeadline: {
    key: 'pmh2.browse.portrait.headline',
    defaultValue: 'Picture yourself in {country} dress.',
  },
  portraitSubline: {
    key: 'pmh2.browse.portrait.subline',
    defaultValue: '{percentage} of your ancestors were from {country}.',
  },
  portraitSublineUnmatched: {
    key: 'pmh2.browse.portrait.subline-unmatched',
    defaultValue: 'Not in your tree — try it on anyway.',
  },
})

export function translate(t, copy, values = {}) {
  const translated = t(copy.key, copy.defaultValue, {
    ...values,
    ...(copy.defaultValue_plural ? { defaultValue_plural: copy.defaultValue_plural } : {}),
  })

  if (typeof translated !== 'string') return translated

  // i18next-icu formats `{name}` placeholders itself, so this normally finds nothing left to do.
  // It stays as a safety net for catalogs that still carry a value i18next did not substitute,
  // and only touches simple `{name}` arguments a caller supplied - never an ICU plural or select
  // block, whose braces must survive untouched.
  return translated.replace(/\{\{\s*([A-Za-z_]\w*)\s*\}\}|\{\s*([A-Za-z_]\w*)\s*\}/g, (match, doubled, single) => {
    const value = values[doubled ?? single]
    return value === null || value === undefined ? match : String(value)
  })
}

function formatNumber(percentage, locale, options) {
  try {
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 2, ...options }).format(percentage)
  } catch {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 2, ...options }).format(percentage)
  }
}

export function formatLocalizedPercentage(percentage, locale) {
  return formatNumber(percentage / 100, locale, { style: 'percent' })
}

export function getBrowsePercentageText(t, percentage, locale) {
  return translate(t, BROWSE_COPY.percentage, {
    percentage: formatLocalizedPercentage(percentage, locale),
  })
}

export function getBrowsePercentageAccessibilityText(t, percentage, locale, country = null) {
  const copy = country ? BROWSE_COPY.detailAccessibility : BROWSE_COPY.percentageAccessibility
  return translate(t, copy, {
    ...(country ? { country } : {}),
    percentage: formatNumber(percentage, locale),
  })
}
